import BaseParagraph from "../baseComponents/baseParagraph";
import { useSelector } from "react-redux";

const WelcomeText = ({ fontSize = null, isCentered = false }) => {
  const userState = useSelector((state) => state.userState);

  const styles = {
    text: { fontSize: fontSize },
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: isCentered === true ? "center" : "flex-start",
        justifyContent: "flex-end",
      }}
    >
      <div>
        <BaseParagraph style={styles.text}>hello</BaseParagraph>
        <div style={{ display: "inline-block", ...styles.text }}>
          &nbsp;{userState.name},
        </div>
      </div>
      <div>
        <BaseParagraph style={styles.text}>tierStatusPrefix</BaseParagraph>
        <BaseParagraph style={styles.text} translate={false}>
          &nbsp;{userState.currentPeriod.tierName}!
        </BaseParagraph>
      </div>
      <BaseParagraph style={styles.text}>enjoyBenefits</BaseParagraph>
    </div>
  );
};

export default WelcomeText;
